import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t bg-white">
      <div className="container mx-auto px-3 sm:px-4 py-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="text-sm text-gray-600">
            © {year} AppReview.ai. All rights reserved.
          </div>
          <nav className="flex items-center gap-4 text-sm text-gray-600">
            <Link to="/privacy" className="hover:text-gray-900 underline">Privacy</Link>
            <Link to="/terms" className="hover:text-gray-900 underline">Terms</Link>
          </nav>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-4 pt-4 border-t border-gray-100">
          <a href="https://turbo0.com/item/appreviewai" target="_blank" rel="noopener noreferrer">
            <img src="https://img.turbo0.com/badge-listed-light.svg" alt="Listed on Turbo0" style={{ height: '32px', width: 'auto' }} />
          </a>
          <a href="https://newtool.site" target="_blank" rel="noopener noreferrer">
            <img src="https://img.shields.io/badge/Featured%20on-NewTool.site-brightgreen?style=flat-square" alt="Featured on NewTool" style={{ height: '24px', width: 'auto' }} />
          </a>
          <a href="https://dang.ai" target="_blank" rel="dofollow noopener noreferrer">
            <img src="https://img.shields.io/badge/Featured%20on-Dang.ai-orange?style=flat-square" alt="Featured on Dang.ai" style={{ height: '24px', width: 'auto' }} />
          </a>
          <a href="https://twelve.tools" target="_blank" rel="noopener noreferrer">
            <img src="https://img.shields.io/badge/Featured%20on-Twelve%20Tools-blue?style=flat-square" alt="Featured on Twelve Tools" style={{ height: '24px', width: 'auto' }} />
          </a>
          <a href="https://findly.tools/appreview-ai" target="_blank" rel="noopener noreferrer">
            <img src="https://findly.tools/badges/findly-tools-badge-light.svg" alt="Featured on findly.tools" style={{ height: '32px', width: 'auto' }} />
          </a>
          <a href="https://fazier.com" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 hover:text-gray-600">Fazier</a>
          <a href="https://www.uneed.best" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 hover:text-gray-600">Uneed</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


